import React from 'react';

import { JsonParam, useQueryParam, withDefault } from 'use-query-params';
import { FiEdit } from 'react-icons/fi';
import { HiOutlineTrash } from 'react-icons/hi';

import { useGetDiscounts } from 'modules/branch/services-management/services/hooks';
import GenericTable from 'modules/common/components/GenericTable';
import EmptyState from 'modules/common/components/EmptyState';
import Pagination from 'modules/common/components/Pagination';
import { Button } from 'modules/common/input';
import { AUTH_TYPE } from 'modules/partial/constants';

import { DEFAULT_FILTER } from './Filter';

function Discounts() {
  const authType = React.useContext(AUTH_TYPE);
  const [query, setQuery] = useQueryParam(
    'recent_transactions',
    withDefault(JsonParam, DEFAULT_FILTER)
  );

  const [isListLoading, list, pagination] = useGetDiscounts({
    params: query,
  });

  const handleOnCreateUpdate = () => {};
  const handleOnRemove = () => {};
  const handleOnChangePage = (page) => {
    setQuery({
      ...query,
      page,
    });
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <div className="flex-1">
          <div className="font-semibold">Discounts</div>
          <div className="text-sm text-gray-500"> </div>
        </div>
        {authType === 'ADMIN' && (
          <div>
            <Button
              label="Add new Discount"
              className="btn primary font-semibold !px-3 sm"
            />
          </div>
        )}
      </div>

      <GenericTable
        data={list}
        isLoading={isListLoading}
        id="discounts-table"
        withHover
        noRowsLabel={<EmptyState />}
        containerClassName="min-h-[300px] max-h-[300px]"
        format={[
          {
            key: 'name',
            label: 'TABLE NAME',
            widthClassName: 'flex-1',
          },
          {
            key: (item) => <>{item?.value}%</>,
            label: 'PERCENTAGE OFF',
            widthClassName: 'flex-1',
          },
          authType === 'ADMIN' && {
            key: () => (
              <div className="flex gap-3.5 items-center">
                <div>
                  <FiEdit
                    className="h-[18px] w-[18px] cursor-pointer"
                    onClick={handleOnCreateUpdate}
                  />
                </div>

                <div>
                  <HiOutlineTrash
                    className="h-5 w-5 text-primary-400 cursor-pointer"
                    onClick={handleOnRemove}
                  />
                </div>
              </div>
            ),
            label: 'ACTIONS',
            widthClassName: 'flex-1',
          },
        ]}
      />

      <Pagination
        value={pagination}
        onChange={handleOnChangePage}
        small
        isLoading={isListLoading}
      />
    </div>
  );
}

Discounts.defaultProps = {};

Discounts.propTypes = {};

export default Discounts;
